const AppRoutes = {
  Dashboard: {
    Home: '/dashboard',
    Supports: {
      Index: '/dashboard/supports',
      Search: '/dashboard/supports/search',
      serviceRequest: '/dashboard/supports/service-request',
      helpForms: '/dashboard/supports/help-forms',
    },
    Services: {
      Index: '/dashboard/services',
      Description: '/dashboard/services/:id/description',
      VillaConfigurator: {
        Index: '/dashboard/services/villa-configurator',
        Summary: '/dashboard/services/villa-configurator/summary',
      },
      UploadDocuments: '/dashboard/services/upload-documents',
      YourRequirements: '/dashboard/services/your-requirements',
      SelectVilla: {
        Index: '/dashboard/services/select-villa',
        VillaId: '/dashboard/services/select-villa/:id',
      },
      SelectContractor: '/dashboard/services/select-contractor',
      SelectConsultant: '/dashboard/services/select-consultant',
      HireConsultant: {
        Index: '/dashboard/services/hire-consultant',
        List: '/dashboard/services/hire-consultant/list',
        YourVision: '/dashboard/services/hire-consultant/your-vision',
        Additional: '/dashboard/services/hire-consultant/additional',
        AddConsultant: '/dashboard/services/hire-consultant/add-consultant',
        Confirmation: '/dashboard/services/hire-consultant/confirmation',
        UploadDocuments: '/dashboard/services/hire-consultant/upload-documents',
      },
      HireContractor: {
        Index: '/dashboard/services/hire-contractor',
        List: '/dashboard/services/hire-contractor/list',
        Additional: '/dashboard/services/hire-contractor/additional',
        AddContractor: '/dashboard/services/hire-contractor/add-contractor',
        Confirmation: '/dashboard/services/hire-contractor/confirmation',
      },
      ProjectCompletion: {
        Index: '/dashboard/services/project-completion',
        SnaggingSiteVisit:
          '/dashboard/services/project-completion/snagging-site-visit',
        rescheduleSiteVisit:
          '/dashboard/services/project-completion/reschedule-site-visit',
        SnaggingUploadDocument:
          '/dashboard/services/project-completion/upload-document',
      },
    },
    MyProfile: '/dashboard/my-profile',
    MyDocuments: '/dashboard/my-documents',
    calendar: '/dashboard/calendar',
    CompareVilla: '/dashboard/my-profile/compare-villas',
    DeListConsultant: '/dashboard/de-listed-consultant',
    DeListContractor: '/dashboard/de-listed-contractor',
  },
  Home: '/',
  LandingPage: '/landing-page',
  OurPartners: '/our-partners',
  EnOurPartners: '/en/our-partners',
  SupportSearchPage: '/support-search-page',
  FindQualifiedVendors: '/find-qualified-vendors',
  villaList: '/villa-list',
  Signup: {
    Customer: '/sign-up/customer',
    NonUpgraded: '/sign-up-non-upgraded',
  },
  Vendor: {
    Index: '/vendor',
    Login: '/vendor/login',
    Registration: {
      Index: '/vendor/registration',
      Consultant: '/vendor/registration/consultant',
      Contractor: '/vendor/registration/contractor',
      CompanyProfile: '/vendor/registration/company-profile',
      VerifyDetails: '/vendor/registration/verify-details',
      Guidelines: '/vendor/registration/guidelines',
      Confirmation: '/vendor/registration/confirmation',
    },
    EmailVerification: '/vendor/email-verification',
  },
  Support: {
    Index: '/support',
    articlesId: '/support/articles/:id',
  },
  TermsAndConditions: '/terms-and-conditions',
  VillaConfigurations: {
    Index: '/villa-configurator',
    Summary: '/villa-configurator/summary',
  },
  Services: '/services',
  NonEligible: '/non-eligible',
  OurStory: '/our-story',
  BeInspired: '/be-inspired',
  Villas: {
    Id: '/villas/:id',
  },
  Authenticate: '/authenticate',
  Logout: '/logout',
} as const;

export default AppRoutes;
